import { render } from "./InternEvaluation.vue?vue&type=template&id=dbb2aa60"
import script from "./InternEvaluation.vue?vue&type=script&lang=js"
export * from "./InternEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__